var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';
export const IndicatorBadge = props => {
    const { as, count, max = 99, dot = false, showZero = false, variant = 'danger', children, className } = props, rest = __rest(props, ["as", "count", "max", "dot", "showZero", "variant", "children", "className"]);
    const Component = as || 'span';
    if (!count || (!showZero && typeof count === 'number' && count <= 0)) {
        return React.createElement(React.Fragment, null, children);
    }
    const colorClsx = [
        variant === 'primary' && 'text-actionPrimary-100 bg-actionPrimary-500',
        variant === 'danger' && 'text-danger-100 bg-danger-500',
    ];
    let content = '';
    if (!dot && typeof count === 'number') {
        if (count > max) {
            content = `${max}+`;
        }
        else if (count <= 0) {
            content = '0';
        }
        else {
            content = String(count);
        }
    }
    const component = (React.createElement(Component, Object.assign({ className: twMerge(clsx(children &&
            'absolute top-0 right-0 transform translate-x-1/2 -translate-y-1/2', colorClsx, 'rounded-full ', !dot &&
            'h-5 inline-flex items-center justify-center px-1.5 py-1 text-xs font-bold leading-none', dot && 'inline-block w-2 h-2', className)) }, rest), content));
    if (children) {
        return (React.createElement("div", { className: clsx('relative inline-block') },
            children,
            component));
    }
    return component;
};
//# sourceMappingURL=IndicatorBadge.js.map